var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2824_7061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2738 19.6842C9.88437 19.6842 9.537 19.4421 9.40016 19.0737L4.36858 5.5684C4.24226 5.23155 4.32648 4.84208 4.57911 4.58945C4.74753 4.42103 4.98963 4.31577 5.23174 4.31577C5.34753 4.31577 5.45279 4.33682 5.55805 4.37892L19.0633 9.4105C19.4317 9.54734 19.6738 9.90524 19.6738 10.2947C19.6738 10.6842 19.4212 11.0316 19.0423 11.1579L13.1686 13.1894L11.137 19.0631C11.0107 19.4316 10.6633 19.6842 10.2738 19.6842Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2824_7061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSelect);
export default __webpack_public_path__ + "static/media/ico-select.ed960ce9345b8a49b5a7c22512f238e1.svg";
export { ForwardRef as ReactComponent };